import { ApiClient } from '.';
import { UploadSets, UploadFiles, DataFrames, Categories, ColumnMapping, Fields, UploadModes, UserDefinedFields, ValueMappingCommits, Currency, Formulas } from './collections';
let client;
if (process.env.REACT_APP_DYSON_API_BASE_URL) {
    client = new ApiClient(process.env.REACT_APP_DYSON_API_BASE_URL);
}
else if (window.location.origin === 'http://ux.payscale.com') {
    client = new ApiClient('http://api.dyson.underpaid.com');
}
else {
    const regExResult = /\/view\/o\/(.+)(\/lab|\/mp)\/?.*/.exec(window.location.pathname);
    const orgCode = regExResult && regExResult[1];
    client = new ApiClient(`${window.location.origin}/${orgCode}/dyson`);
}
export default {
    baseUrl: client.baseURL,
    uploadSet: UploadSets(client),
    uploadFile: UploadFiles(client),
    dataFrame: DataFrames(client),
    categories: Categories(client),
    columnMapping: ColumnMapping(client),
    fields: Fields(client),
    uploadModes: UploadModes(client),
    userDefinedFields: UserDefinedFields(client),
    valueMappingCommits: ValueMappingCommits(client),
    currency: Currency(client),
    formulas: Formulas(client)
};
